import { Link } from 'react-router-dom';
import SafeImage from '../../components/SafeImage';
import './social-media.css';

function layoutKey(count) {
  if (count <= 1) return '1';
  if (count === 2) return '2';
  if (count === 3) return '3';
  if (count === 4) return '4';
  return '5plus';
}

function MediaCell({ item, alt, href, overlay = '' }) {
  const image = (
    <SafeImage className="post-media-gallery__image" src={item.url} alt={alt} />
  );
  const frameClass = 'post-media-gallery__cell';
  if (href) {
    return (
      <Link className={frameClass} to={href}>
        {image}
        {overlay ? <span className="post-media-gallery__overlay" aria-hidden="true">{overlay}</span> : null}
      </Link>
    );
  }
  return (
    <div className={frameClass}>
      {image}
      {overlay ? <span className="post-media-gallery__overlay" aria-hidden="true">{overlay}</span> : null}
    </div>
  );
}

export default function PostMediaGallery({
  media = [],
  alt = '旅遊圖片',
  href = '',
  className = '',
}) {
  const items = Array.isArray(media) ? media : [];
  if (!items.length) return null;

  const count = items.length;
  const layout = layoutKey(count);
  const visible = count > 4 ? items.slice(0, 4) : items;
  const overlayOnFourth = count > 4 ? `+${count - 4}` : '';

  const rootClass = [
    'post-media-gallery',
    `post-media-gallery--layout-${layout}`,
    className,
  ].filter(Boolean).join(' ');

  // 單圖外層已包 Link 時，格子不再各自包 Link，避免巢狀連結。
  const cellHref = href && layout === '1' ? '' : href;

  const grid = (
    <div className="post-media-gallery__grid">
      {visible.map((item, index) => (
        <MediaCell
          key={item.fileReference || item.url || index}
          item={item}
          alt={alt}
          href={cellHref}
          overlay={index === 3 && overlayOnFourth ? overlayOnFourth : ''}
        />
      ))}
    </div>
  );

  return (
    <div className={rootClass} data-testid="post-media-gallery">
      {href && layout === '1' ? (
        <Link className="post-media-gallery__link" to={href}>{grid}</Link>
      ) : grid}
    </div>
  );
}
